import { all, takeEvery, call, put } from "redux-saga/effects";
import {
  detail,
  update,
  getDatetime,
  setDatetime,
  shutdown,
  factoryReset,
  factoryResetStatus,
  exportConfig,
  importConfig,
} from "services/apis/setting";
import actions from "./actions";
import { toastr } from "services/toastr";

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* DETAIL() {
  yield loading(true);

  const response = yield call(detail);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
        isSystemDetailFetched: true,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* DETAIL_ONLY_LAYOUT() {
  yield loading(true);

  const response = yield call(detail);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detailForLayout: response,
        loading: false,
        isSystemDetailFetchedForLayout: true,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* CLEAR_DETAIL_ONLY_LAYOUT() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      detailForLayout: {},
      loading: false,
      isSystemDetailFetchedForLayout: false,
    },
  });
}

export function* UPDATE({ payload }) {
  const { body } = payload;
  yield loading(true);

  const response = yield call(update, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    yield put({ type: actions.DETAIL_ONLY_LAYOUT });

    toastr.success("update succeeded", "updated setting!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* GET_DATETIME() {
  yield loading(true);

  const response = yield call(getDatetime);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        datetimeSetting: response,
        loading: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* SET_DATETIME({ payload }) {
  const { body } = payload;
  yield loading(true);

  const response = yield call(setDatetime, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        datetimeSetting: response,
        loading: false,
      },
    });

    toastr.success("update succeeded", "updated datetime setting!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* SHUTDOWN() {
  yield loading(true);

  const response = yield call(shutdown);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        shutdownResponse: response,
        loading: false,
      },
    });

    toastr.warning("shutting down", "system application is shutting down!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* FACTORY_RESET({ payload }) {
  const { body } = payload;
  yield loading(true);

  const response = yield call(factoryReset, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        resetResponse: response,
        loading: false,
        resetError: false,
      },
    });

    toastr.warning("factory reset", "factory resetting please wait!");
  }

  if (!response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        resetError: true,
      },
    });
  }
}

export function* FACTORY_RESET_STATUS() {
  yield loading(true);

  const response = yield call(factoryResetStatus);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* EXPORT() {
  yield loading(true);

  const response = yield call(exportConfig);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        error: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* IMPORT({ payload }) {
  const { body } = payload;
  yield loading(true);

  const response = yield call(importConfig, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        importStatus: response.status,
        loading: false,
        importError: false,
      },
    });

    toastr.success("import succeeded", "imported configurations!");
  }

  if (!response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        importStatus: "unknown",
        loading: false,
        importError: true,
      },
    });
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DETAIL, DETAIL),
    takeEvery(actions.UPDATE, UPDATE),
    takeEvery(actions.GET_DATETIME, GET_DATETIME),
    takeEvery(actions.SET_DATETIME, SET_DATETIME),
    takeEvery(actions.SHUTDOWN, SHUTDOWN),
    takeEvery(actions.FACTORY_RESET, FACTORY_RESET),
    takeEvery(actions.EXPORT, EXPORT),
    takeEvery(actions.IMPORT, IMPORT),
    takeEvery(actions.FACTORY_RESET_STATUS, FACTORY_RESET_STATUS),
    takeEvery(actions.DETAIL_ONLY_LAYOUT, DETAIL_ONLY_LAYOUT),
    takeEvery(actions.CLEAR_DETAIL_ONLY_LAYOUT, CLEAR_DETAIL_ONLY_LAYOUT),
  ]);
}
